import { render } from "./RainJoin.vue?vue&type=template&id=6712aaa0&scoped=true"
import script from "./RainJoin.vue?vue&type=script&lang=js"
export * from "./RainJoin.vue?vue&type=script&lang=js"

import "./RainJoin.vue?vue&type=style&index=0&id=6712aaa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6712aaa0"]])

export default __exports__